var $579b7ae9c5494112$exports = {};
$579b7ae9c5494112$exports = {
  "pending": "nere\u0161eno"
};
export { $579b7ae9c5494112$exports as default };